import { useCallback } from 'react';

import { navigateToTeamsApp as navigateToTeamsAppBase } from '@atlaskit/teams-app-config/navigation';
import type {
	NavigationActionPayloadVariants,
	NavigationResult,
} from '@atlaskit/teams-app-config/types';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData';
import { expValEquals } from '@confluence/feature-experiments';

import { getIsNav4EnabledSafe } from './getIsNav4EnabledSafe';

export const useGetNavigateToTeamsApp = (): ((
	navActionPayload: NavigationActionPayloadVariants,
	shouldOpenInSameTab?: boolean,
) => NavigationResult) => {
	const { cloudId, orgId } = useSessionData();

	const getNavigateToTeamsApp = (
		navActionPayload: NavigationActionPayloadVariants,
		shouldOpenInSameTab?: boolean,
	): NavigationResult => {
		return navigateToTeamsAppBase({
			hostProduct: 'confluence',
			orgId,
			cloudId,
			userHasNav4Enabled: getIsNav4EnabledSafe(),
			shouldOpenInSameTab,
			...navActionPayload,
		});
	};

	const getNavigateToTeamsAppCallback = useCallback(getNavigateToTeamsApp, [cloudId, orgId]);

	return expValEquals('confluence_edit_page_rerender_optimizations', 'isEnabled', true)
		? getNavigateToTeamsAppCallback
		: getNavigateToTeamsApp;
};
